import { IDetailPageData } from "../../../shared/utils/api";

export interface IDomainTypeStage {
  id: string;
  name: string;
  screen_id: string;
  position: number;
}

export interface IBackendDomainType {
  id: string;
  name: string;
  active: boolean;
  alertcase_id_prefix: string;
  stages: IDomainTypeStage[];
}

export function transformToBackendDomainType(data: IDetailPageData): IBackendDomainType {
  return {
    id: data.id || "",
    name: data.name || "",
    active: data.active,
    alertcase_id_prefix: data.alertcase_id_prefix || "",
    stages: data.stages.map((stage: any) => ({ // eslint-disable-line
      id: stage.id,
      name: stage.name,
      screen_id: stage.screen_id,
      position: stage.position
    }))
  };
}

export function transformFromBackendDomainType(backendType: IBackendDomainType): IDetailPageData {
  return {
    rowData: [],
    id: backendType.id || "",
    name: backendType.name || "",
    active: backendType.active,
    alertcase_id_prefix: backendType.alertcase_id_prefix || "",
    stages: backendType.stages.map((stage: any) => ({ // eslint-disable-line
      id: stage.id,
      name: stage.name,
      screen_id: stage.screen_id,
      position: stage.position,
      screen_name: stage.screen_name
    }))
  };
}